import LendingResults from './LendingResults';

export default LendingResults;
